import React from 'react';
import { react2panel } from 'common/util/react2panel';
import { QueryBuilderReact } from './index';
import type { QueryBuilderProps } from './types';
export const QueryBuilderEl = react2panel("mp-query-builder", (props: QueryBuilderProps & {
  root?: React.ReactNode;
}) => <QueryBuilderReact {...props} />, {
  contexts: ["reportBookmark"]
});